

// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import { ReactComponent as ChevronDownIcon } from "bootstrap-icons/icons/chevron-down.svg";
// import { getSidebarSections } from "./SideBarConfig";
// import { AuthContext } from "../AuthProvider/AuthProvider";
// import LogoutButton from "./utils/LogoutButton";

// const MobileDropdownNavbar = () => {
//   const { permissions } = useContext(AuthContext);
//   const [openSections, setOpenSections] = useState({});
//   const sidebarSections = getSidebarSections(permissions);

//   const toggleSection = (key) => {
//     setOpenSections((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   return (
//     <aside className="flex-1 space-y-1 md:hidden">
//       <p className="block p-2 text-xl font-medium tracking-tighter text-darkGreen3 transition duration-500 ease-in-out transform cursor-pointer hover:text-gray-900 mx-auto mb-3">
//         Dashboard
//       </p>

//       <hr className="border border-lGrey" />

//       {sidebarSections.map(({ key, title, links, show }) => (
//         show && (
//           <div key={key} className="rounded-lg">
//             <button
//               className="flex justify-between w-full px-4 py-2 text-left bg-gray-200 rounded-t-lg focus:outline-none"
//               onClick={() => toggleSection(key)}
//             >
//               <span className="text-black2">{title}</span>
//               <ChevronDownIcon
//                 className={`transform transition-transform ${openSections[key] ? "rotate-180" : "rotate-0"
//                   }`}
//               />
//             </button>

//             {openSections[key] && (
//               <div className="p-4 bg-white rounded-b-lg">
//                 <ul>
//                   {links.map((link) => (
//                     <li key={link.to}>
//                       <Link
//                         to={link.to}
//                         className="text-grey3 hover:text-darkGreen3 inline-flex items-center w-full mt-1 text-base transition duration-500 ease-in-out transform rounded-lg focus:shadow-outline"
//                       >
//                         <span>{link.label}</span>
//                       </Link>
//                     </li>
//                   ))}
//                   {/* logout button here */}
//                   <div div className="rounded-lg mx-4 mt-2" >
//                     <LogoutButton />
//                   </div>
//                 </ul>

//               </div>
//             )}
//             <hr className="border border-lGrey" />
//           </div>
//         )
//       ))}
//     </aside>
//   );
// };

// export default MobileDropdownNavbar;

import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ChevronDownIcon } from "bootstrap-icons/icons/chevron-down.svg";
import { getSidebarSections } from "./SideBarConfig";
import { AuthContext } from "../AuthProvider/AuthProvider";
import LogoutButton from "./utils/LogoutButton";
import { ReactComponent as BoxArrowRight } from "bootstrap-icons/icons/box-arrow-right.svg";
import { ReactComponent as PeopleFill } from "bootstrap-icons/icons/people-fill.svg";
import { ReactComponent as BuildingsFill } from "bootstrap-icons/icons/buildings-fill.svg";

import { usePortal } from "../AuthProvider/PortalProvider";

const MobileDropdownNavbar = ({ handlePortalSwitch }) => {
  const { permissions } = useContext(AuthContext);
  const [openSections, setOpenSections] = useState({});
  // const sidebarSections = getSidebarSections(permissions);
  const { portal ,switchPortal} = usePortal();
  const sidebarSections = getSidebarSections(permissions, portal);


  const toggleSection = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <aside className="flex-1 space-y-1 md:hidden">
      <div className="px-4 py-2">
        <h2 className="text-xl font-medium text-darkGreen3 mb-2">Switch Portal</h2>

        <div className="flex gap-4">
          <Link
            to="/admin/dashboard"
            onClick={() => switchPortal("admin")}
            className={`p-3 rounded-full flex items-center justify-center transition-colors ${portal === "admin"
                ? "bg-orange1 text-white"
                : "bg-green1 text-white hover:bg-green2"
              }`}
            title="Admin Portal"
          >
            <PeopleFill className="text-xl" />
          </Link>

          <Link
            to="/operations/branch/dashboard"
            onClick={() => switchPortal("operations")}
            className={`p-3 rounded-full flex items-center justify-center transition-colors ${portal === "operations"
                ? "bg-orange1 text-white"
                : "bg-green1 text-white hover:bg-green2"
              }`}
            title="Branch Portal"
          >
            <BuildingsFill className="text-xl" />
          </Link>
        </div>

        {/* <hr className="my-4 border-grey3" /> */}
      </div>



      <hr className="border border-lGrey" />

      {sidebarSections.map(({ key, title, links, show }) => (
        show && (
          <React.Fragment key={key}>
            <div className="rounded-lg">
              <button
                className="flex justify-between w-full px-4 py-2 text-left bg-gray-200 rounded-t-lg focus:outline-none"
                onClick={() => toggleSection(key)}
              >
                <span className="text-black2">{title}</span>
                <ChevronDownIcon
                  className={`transform transition-transform ${openSections[key] ? "rotate-180" : "rotate-0"
                    }`}
                />
              </button>

              {openSections[key] && (
                <div className="p-4 bg-white rounded-b-lg">
                  <ul>
                    {links.map((link) => (
                      <li key={link.to}>
                        <Link
                          to={link.to}
                          className="text-grey3 hover:text-darkGreen3 inline-flex items-center w-full mt-1 text-base transition duration-500 ease-in-out transform rounded-lg focus:shadow-outline"
                        >
                          <span>{link.label}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>


                </div>
              )}
            </div>
            <hr className="border border-lGrey" />
          </React.Fragment>
        )
      ))}

      {/* Logout Button - Placed outside the sections loop */}
      <div className="px-4 py-2">
        <LogoutButton className="w-full text-left" />
      </div>
    </aside>
  );
};

export default MobileDropdownNavbar;